// extracted by mini-css-extract-plugin
module.exports = {"list":"carousel_list__ETg0I","item":"carousel_item__Xcn_r","dot":"carousel_dot__xlv2n","dotActive":"carousel_dotActive__zj07R"};